export default {
  title: '',
  homeMenu: {
    name: '我的申请历史',
    desc: '查看申请历史'
  },
  label: {
    company: '公司名称',
    project: '职位名称',
    status: '状态',
    action: '操作',
    date: '日期',
    completedApplication: '已完成的申请',
    incompleteApplication: '未完成的申请',
    removeOneApplication: '您确认撤销{jobTitle}的申请吗？',
    removeAllApplication: '您确认撤销吗？如果确认，您投递（{companyName}）所有申请将会被移除。'
  },
  btn: {
    revokeThis: '撤销此申请',
    revokeAll: '撤销所有申请',
    needProfile: '请完成档案',
    needPersonalitySurvey: '请完成价值观&优势测评',
    needProblemSolving: '请完成问题解决能力的评测',
    needMiniSurvey: '请完成职位申请问卷调查',
    needInviteSurvey: '请完成邀请回答的问题',
    needToAgreePolicy: '继续完成申请',
    continueFinishQuestion: '继续完成问答',
    continueFinishApply: '继续完成申请',
    yes: '是',
    no: '否'
  },
  message: {
    revokeSuccess: '撤销成功'
  }
}
